import { AppContent } from '@dtx-company/inter-app/src/redux/slices/app-content-slice'
import { FC, ReactNode } from 'react'
import { Provider } from 'react-redux'
import { useInitializeReduxStore } from '../hooks/useInitializeReduxStore'

interface Props {
  appContent: AppContent
  children: ReactNode
}

export const ReduxProvider: FC<Props> = ({ appContent, children }) => {
  const [store] = useInitializeReduxStore(appContent)

  return <Provider store={store}>{children}</Provider>
}
//
